import {
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Divider,
} from '@mui/material';
import { MdCheck } from 'react-icons/md';

export default function SettingsScreen() {
  return (
    <Box>
      {/* Header */}
      <Box className="mb-6">
        <Typography variant="h5" className="font-bold text-slate-900">
          Settings
        </Typography>
        <Typography variant="body2" className="text-slate-600 mt-1">
          Configure platform settings and preferences
        </Typography>
      </Box>

      {/* General Settings */}
      <Paper
        elevation={0}
        sx={{
          mb: 3,
          borderRadius: '16px',
          border: '1px solid #E2E8F0',
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h6" className="font-semibold mb-4">
            General Settings
          </Typography>
          <Box className="space-y-4">
            <TextField
              fullWidth
              label="Platform Name"
              defaultValue="Intraverse"
              helperText="Display name for your platform"
            />
            <TextField
              fullWidth
              label="Support Email"
              defaultValue="support@intraverse.com"
              helperText="Email for customer support inquiries"
            />
            <TextField
              fullWidth
              label="Company Name"
              defaultValue="Intraverse Technologies"
              helperText="Legal company name"
            />
          </Box>
        </CardContent>
      </Paper>

      {/* Save Button */}
      <Box className="flex justify-end">
        <Button
          variant="contained"
          startIcon={<MdCheck />}
          sx={{
            bgcolor: '#1F4FFF',
            textTransform: 'none',
            px: 4,
            py: 1.5,
            borderRadius: '10px',
            fontWeight: 600,
            '&:hover': {
              bgcolor: '#1a40d9',
            },
          }}
        >
          Save Settings
        </Button>
      </Box>
    </Box>
  );
}
